import { render, staticRenderFns } from "./FancyBreak.vue?vue&type=template&id=7499fa46&scoped=true&"
var script = {}
import style0 from "./FancyBreak.vue?vue&type=style&index=0&id=7499fa46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7499fa46",
  null
  
)

export default component.exports